import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';


import Navigation from '../Navigation';
// import LandingPage from '../Landing';
import SignUpPage from '../SignUp';
import SignInPage from '../SignIn';
// import PasswordForgetPage from '../PasswordForget';
import HomePage from '../Home';
// import AccountPage from '../Account';
// import AdminPage from '../Admin';

import * as ROUTES from '../../constants/routes';

import { withAuthentication } from '../Session';
import { NewSoundtrailScreen } from '../NewSoundtrail';
import { EditSoundtrailScreen } from '../EditSoundtrail';

const App = () => (
  <Router>
    <div>
      <Navigation />

      <Route exact path={ROUTES.LANDING} component={HomePage} />
      <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
      <Route path={ROUTES.SIGN_IN} component={SignInPage} />
      <Route path={ROUTES.HOME} component={HomePage} />
      <Route path={ROUTES.NEW_SOUNDTRAIL} component={NewSoundtrailScreen} />
      <Route path={ROUTES.EDIT_SOUNDTRAIL} component={EditSoundtrailScreen} />
      {/* <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage} />
      <Route path={ROUTES.ACCOUNT} component={AccountPage} />
      <Route path={ROUTES.ADMIN} component={AdminPage} /> */}
    </div>
  </Router>
);

export default withAuthentication(App);